var exports = {
  "k": "x234b8571--9d8891--container",
};

module.exports = exports;
